export default __webpack_public_path__ + "static/media/software-engineer.739b8cd5.svg";